import type {
  DoctorShiftRuleRepository,
  DoctorShiftRuleFilter,
  DoctorShiftRuleListResult
} from './ports/DoctorShiftRuleRepository';

const DEFAULT_FILTER: DoctorShiftRuleFilter = {
  page: 1,
  pageSize: 100
};

export interface FetchDoctorShiftRulesInput {
  filter?: DoctorShiftRuleFilter;
}

export interface FetchDoctorShiftRulesOutput {
  result: DoctorShiftRuleListResult;
}

/**
 * 医師シフトルール一覧を取得するUseCase
 * @param repository DoctorShiftRuleRepository リポジトリインスタンス
 * @param input FetchDoctorShiftRulesInput 取得条件（フィルター、デフォルト: pageSize=100）
 * @returns Promise<FetchDoctorShiftRulesOutput> 取得結果
 */
export async function fetchDoctorShiftRules(
  repository: DoctorShiftRuleRepository,
  input: FetchDoctorShiftRulesInput = {}
): Promise<FetchDoctorShiftRulesOutput> {
  const filter: DoctorShiftRuleFilter = {
    ...DEFAULT_FILTER,
    ...input.filter
  };

  const result = await repository.findAll(filter);

  return { result };
}
